import React from 'react'
import { Field, WatchField } from '../../form'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import { withStyles } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'
import { alvPercentageItems, costTypeItems } from '../../utils/invoice.utils'
import FontAwesome from 'react-fontawesome'
import { Translation } from 'react-i18next'
import mobileView from '../../utils/mobile.utils'
import { NumberInput } from '../../utils/numberFormat'
import useDebouncedEffect from '../../utils/useDebouncedEffect'

const styles = (theme) => ({
  tablecell: {
    fontWeight: 'normal',
    fontSize: '13px',
    color: '#9e9e9e',
    paddingRight: '10px !important',
    paddingLeft: '10px !important'
  },
  tablecellSelect: {
    fontWeight: 'normal',
    fontSize: '13px',
    color: '#9e9e9e',
    padding: '1px 10px 0px !important'
  },
  select: {
    marginTop: '-18px !important',
    minWidth: 20,
    fontSize: '14px',
    fontWeight: '500',
    border: '1px solid gray',
    fontFamily: 'Poppins, sans-serif'
  },
  textField: {
    marginTop: 7,
    minWidth: 80,
    fontWeight: '500',
    border: '1px solid gray',
    fontFamily: 'Poppins, sans-serif'
  },
  textField1: {
    marginTop: theme.spacing(3),
    minWidth: 50,
    border: '1px solid gray',
    fontFamily: 'Poppins, sans-serif'
  },
  select1: {
    marginTop: theme.spacing(3),
    minWidth: 20,
    fontSize: '14px',
    border: '1px solid gray',
    fontFamily: 'Poppins, sans-serif',
    padding: '1.6px 0px'
  },
  resize: {
    fontSize: '14px'
  },
  margin: {
    margin: theme.spacing(1)
  }
})

const ExpenseInputRow = ({
  description,
  sum,
  vat,
  cost_type,
  index,
  autoFocusIndex,
  sumWithoutVat,
  classes,
  control,
  remove,
  setValue,
  isReadOnly
}) => {
  const { t } = useTranslation()

  function removeRow() {
    remove(index)
  }

  return mobileView ? (
    _createNewExpenseInputRowMobile(
      cost_type,
      description,
      sum,
      vat,
      sumWithoutVat,
      index,
      autoFocusIndex,
      classes,
      control,
      removeRow,
      setValue,
      isReadOnly
    )
  ) : (
    <TableRow className="dashboard-invoice-inputrow">
      <TableCell className={classes.tablecellSelect}>
        <div style={{ marginBottom: '8px' }}>
          <Field
            name={cost_type}
            inputType="select"
            className={classes.select}
            disabled={isReadOnly}
            control={control}
          >
            {costTypeItems(t)}
          </Field>
        </div>
      </TableCell>
      <TableCell className={classes.tablecell}>
        {parseInt(autoFocusIndex) > 0 ? (
          <Field
            className={classNames(classes.textField, classes.resize)}
            name={description}
            inputType="textfield"
            control={control}
            disabled={isReadOnly}
            autoFocus
            helperTextStyle={{ marginTop: '0px', height: '0px' }}
          />
        ) : (
          <Field
            className={classNames(classes.textField, classes.resize)}
            name={description}
            inputType="textfield"
            disabled={isReadOnly}
            control={control}
            helperTextStyle={{ marginTop: '0px', height: '0px' }}
          />
        )}
      </TableCell>
      <TableCell className={classes.tablecell}>
        <Field
          name={sum}
          inputType="textfield"
          className={classNames(classes.textField, classes.resize)}
          inputComponent={LimitedNumberInput}
          control={control}
          disabled={isReadOnly}
          helperTextStyle={{ marginTop: '0px', height: '0px' }}
        />
      </TableCell>
      <TableCell className={classes.tablecellSelect}>
        <div style={{ marginBottom: '8px' }}>
          <Field
            name={vat}
            inputType="select"
            className={classes.select}
            control={control}
            disabled={isReadOnly}
          >
            {alvPercentageItems}
          </Field>
        </div>
      </TableCell>
      <TableCell className={classes.tablecell}>
        <WatchField
          control={control}
          fields={[
            `expenseInputRow.${index}.sum`,
            `expenseInputRow.${index}.vat`
          ]}
        >
          {(watch) => {
            let sumValue = parseFloat(watch[`expenseInputRow.${index}.sum`])
            let vatValue = watch[`expenseInputRow.${index}.vat`] ?? 0
            let sumWithoutVatValue =
              Math.round((sumValue / (1 + vatValue / 100)) * 100) / 100
            if (isNaN(sumWithoutVatValue)) sumWithoutVatValue = 0
            return (
              <SumField
                name={sumWithoutVat}
                inputType="textfield"
                className={classNames(classes.textField, classes.resize)}
                disabled={true}
                control={control}
                inputComponent={FixedNumberInput}
                setValue={setValue}
                watchValue={sumWithoutVatValue}
              />
            )
          }}
        </WatchField>
      </TableCell>
      <TableCell className={classes.tablecell}>
        <IconButton
          aria-label="Delete"
          className={classes.margin}
          onClick={removeRow}
          key={index}
          disabled={isReadOnly}
        >
          <FontAwesome
            name="window-close"
            style={{
              color: isReadOnly ? 'Gray' : '#F67131',
              opacity: isReadOnly ? 0.7 : 1
            }}
          />
        </IconButton>
      </TableCell>
    </TableRow>
  )
}

const SumField = ({ name, watchValue, setValue, ...rest }) => {
  useDebouncedEffect(setValue, [name, watchValue.toString()], 300)

  return <Field name={name} {...rest} />
}

const _createNewExpenseInputRowMobile = (
  cost_type,
  description,
  sum,
  vat,
  sumWithoutVat,
  index,
  autoFocusIndex,
  classes,
  control,
  removeRow,
  setValue,
  isReadOnly
) => (
  <Translation>
    {(t) => {
      return (
        <div className="panel-body">
          <Field
            name={cost_type}
            inputType="select"
            className={classes.select1}
            disabled={isReadOnly}
            label={t('newExpenc.costs')}
            control={control}
          >
            {costTypeItems(t)}
          </Field>
          {parseInt(autoFocusIndex) > 0 ? (
            <Field
              className={classNames(classes.textField1, classes.resize)}
              name={description}
              inputType="textfield"
              autoFocus
              label={t('newExpenc.table')}
              disabled={isReadOnly}
              control={control}
            />
          ) : (
            <Field
              className={classNames(classes.textField1, classes.resize)}
              name={description}
              inputType="textfield"
              label={t('newExpenc.table')}
              disabled={isReadOnly}
              control={control}
            />
          )}
          <Field
            name={sum}
            inputType="textfield"
            className={classNames(classes.textField1, classes.resize)}
            label={t('newExpenc.table2')}
            inputComponent={LimitedNumberInput}
            control={control}
            disabled={isReadOnly}
          />
          <Field
            name={vat}
            inputType="select"
            className={classes.select1}
            label={t('newExpenc.table3')}
            control={control}
            disabled={isReadOnly}
          >
            {alvPercentageItems}
          </Field>
          <WatchField
            control={control}
            fields={[
              `expenseInputRow.${index}.sum`,
              `expenseInputRow.${index}.vat`
            ]}
          >
            {(watch) => {
              let sumValue = parseFloat(watch[`expenseInputRow.${index}.sum`])
              let vatValue = watch[`expenseInputRow.${index}.vat`] ?? 0
              let sumWithoutVatValue =
                Math.round((sumValue / (1 + vatValue / 100)) * 100) / 100
              if (isNaN(sumWithoutVatValue)) sumWithoutVatValue = 0
              return (
                <SumField
                  name={sumWithoutVat}
                  inputType="textfield"
                  className={classNames(classes.textField1, classes.resize)}
                  label={t('newExpenc.sumWithoutVat')}
                  style={{ paddingBottom: '8px' }}
                  disabled={true}
                  control={control}
                  inputComponent={FixedNumberInput}
                  setValue={setValue}
                  watchValue={sumWithoutVatValue}
                />
              )
            }}
          </WatchField>
          <IconButton
            aria-label="Delete"
            onClick={removeRow}
            key={index}
            style={{ paddingLeft: 0 }}
            disabled={isReadOnly}
          >
            <FontAwesome
              name="window-close"
              style={{
                color: '#F67131',
                marginRight: 10,
                opacity: isReadOnly ? 0.7 : 1
              }}
            />
            <span>{t('newExpenc.table4')}</span>
          </IconButton>
        </div>
      )
    }}
  </Translation>
)

const LimitedNumberInput = (props) => {
  return <NumberInput {...props} decimalScale={2} characterLimit={10} />
}

const FixedNumberInput = (props) => {
  return <NumberInput {...props} decimalScale={2} fixedDecimalScale={true} />
}

ExpenseInputRow.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(ExpenseInputRow)
